import * as coreApi from "api/Core";
import { AppImages } from 'assets/appResources';
import { ReactAutoComplete, ReactAutoCompleteProps } from 'components/AutoComplete';
import HtmlUtils from 'lib/HtmlUtils';
import { PublicationSuggestionDto } from 'models/ApiModels';
import * as React from 'react';
import { RoutePaths } from "routes/RouteConfig";
import Session from 'services/Session';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps extends Omit<ReactAutoCompleteProps, "selectedItems" | "onGetSuggestions" | "onChange" | "onValidate"> {
    userId?: string;
    showAvatar?: boolean;
    selectedItems?: PublicationSuggestionDto[];
    onChange: (data: PublicationSuggestionDto[]) => void;
    onValidate?: (item: PublicationSuggestionDto) => boolean;
}

type Props = IProps;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default class CourseAutoComplete extends React.Component<Props, IState> {

    private apiGetData = coreApi.getCourseSuggestions();

    ///
    static defaultProps = {
        autoFocus: false,
        showAvatar: true,
        multiple: true,
        readonly: false
    };

    ///
    private getSuggestions(searchText: string, skipRecords: number, takeRecords: number): Promise<PublicationSuggestionDto[]> {
        const inputValue = searchText.trim().toLowerCase();

        return new Promise<PublicationSuggestionDto[]>((resolve, reject) => {

            this.apiGetData.execute(
                {
                    userId: this.props.userId || Session.user.id,
                    searchText: inputValue,
                    offset: skipRecords,
                    take: takeRecords
                }
            )
                .then((result) => {

                    result.forEach((v) => {
                        if (v.thumbnailUrl == null) v.thumbnailUrl = AppImages.DefaultPublicationThumbnail;
                    });

                    resolve(result);
                })
                .catch((error) => reject(error));
        });
    }

    ///
    private handleUpdateSelection = (items: Array<PublicationSuggestionDto>) => {
        this.props.onChange(items);
    };

    ///
    private handleSelectedItemClick = (item: PublicationSuggestionDto) => {
        HtmlUtils.openUrlInNewWindow(RoutePaths.PublicationCourseViewer.replace(":id", item.key));
    };

    ///
    private handleResolveAvatar(item: PublicationSuggestionDto): JSX.Element {
        // Provisório. Será revisto na v2.
        return null;

        //return this.props.showAvatar && item.hasMemberRestriction !== null
        //    ? <Avatar><FontAwesomeIcon fixedWidth icon={item.hasMemberRestriction === true ? faLock : faLockOpen} /></Avatar>
        //    : null;
    }

    ///
    public render() {
        const { selectedItems, onValidate, ...rest } = this.props;
        return (
            <ReactAutoComplete
                {...rest}
                selectedItems={selectedItems}
                onGetSuggestions={(searchText, skipRecords, takeRecords) => this.getSuggestions(searchText, skipRecords, takeRecords)}
                onResolveAvatar={(item) => this.handleResolveAvatar(item as PublicationSuggestionDto)}
                onValidate={(item) => (!onValidate || onValidate(item as PublicationSuggestionDto))}
                onChange={this.handleUpdateSelection}
                onSelectedItemClick={this.handleSelectedItemClick}
            />
        );
    }
}